import {Header as LunaHeader, HeaderLogo} from '@sainsburys-tech/luna-header'
import Navbar from '../Navbar/navbar'

const Header = () => {
  return (
      <LunaHeader>
        <HeaderLogo>

          Logistics Data Management

          {}

        </HeaderLogo>
        <Navbar/>

      </LunaHeader>
  )
}

export default Header
